import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import {
  MillionCombinations1,
  MillionCombinations2,
  MillionCombinations3,
  QuizButton,
  RecommendationButton,
} from '../../Constants';
import CustomLink from '../CustomLink';

const MillionCombinations = ({ slug, isFocusArea, dark }) => {
  const { t } = useTranslation();
  return (
    <div className={`t-w-full t-flex t-flex-col t-items-center t-justify-center t-p-6 sm:t-gap-4 ${dark ? 't-bg-navy t-pb-14' : 't-bg-primary'}`}>
      {dark && (
        <style>{`
          @keyframes mcPulse {
            0%, 100% { box-shadow: 0 0 0 0 rgba(246, 225, 71, 0.45); }
            50% { box-shadow: 0 0 0 10px rgba(246, 225, 71, 0); }
          }
          .mc-cta { animation: mcPulse 2.2s ease-in-out infinite; }
          .mc-cta:active { transform: scale(0.97); }
          .mc-arrow { display: inline-block; transition: transform 0.2s ease; }
          .mc-cta:hover .mc-arrow { transform: translateX(5px); }
        `}</style>
      )}
      <h2 className={`t-text-center t-font-serif t-font-normal t-text-[24px] md:t-text-[30px] ${dark ? 't-text-white' : ''}`}>
        {t(MillionCombinations1)} {t(MillionCombinations2)}
      </h2>
      <h1 className={`t-font-serif t-italic t-font-normal t-text-[32px] md:t-text-[42px] ${dark ? 't-text-butter' : 't-text-quaternary'}`}>
        {t(MillionCombinations3)}
      </h1>
      <CustomLink to="/quiz">
        <span className={`btn t-font-sans !t-rounded-lg t-inline-flex t-items-center t-gap-2 ${dark ? 'mc-cta btn-custom-tertiary !t-bg-butter !t-text-navy' : 'btn-custom-secondary'}`}>
          {isFocusArea ? t(QuizButton) : t(RecommendationButton)}
          <span className="mc-arrow">→</span>
        </span>
      </CustomLink>
    </div>
  );
};

export default MillionCombinations;
